<template>
  <div class="field">
    <input type="text" v-model="model" class="input" />
    <div class="currency">
      <img :src="icon" width="15" height="15" :alt="currency" />
      <span>
        {{ props.currency }}
      </span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  currency: String,
  icon: String
})

const model = defineModel()
</script>

<style lang="scss" scoped>
.field {
  position: relative;
}

.input {
  border: 0;
  background: transparent;
  font-size: 1.8rem;
  font-weight: 500;
  border-radius: 10px;
  background: var(--Banner-5, rgba(0, 0, 0, 0.05));
  color: var(--Text, #000);
  height: 43px;
  padding: 4px 80px 0 20px;
  line-height: 50px;
  max-width: 100%;

  &:focus {
    outline: none;
  }
}

.currency {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 3px;
  right: 10px;
  top: 10px;
  bottom: 10px;

  background: var(--bubble-10, rgba(0, 0, 0, 0.1));
  padding: 4px 7px 4px 4px;
  border-radius: 20px;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 100%;

  span {
    padding-top: 2px;
  }
}
</style>
